import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CustomPage extends Vue {
    @Prop() private hideBar!: boolean;
    @Prop() private centerContent!: boolean;
    @Prop() private isLoading!: boolean;
}
